import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '.../../environments/environment';
import { AuthService } from '../../../_services/index';
import { LoaderService } from 'app/_services/loader.service';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { process, State } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { Observable } from 'rxjs';
//import { InventoryService } from './inventory.service';
declare var $: any;

import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
import { ThemeService } from '@progress/kendo-angular-charts';
const moment = _rollupMoment || _moment;

const distinctCat = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.CATNAME === x.CATNAME) === idx);
const distinctSubCat = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.SUBCATNAME === x.SUBCATNAME) === idx);
const distinctPartType = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.PARTTYPENAME === x.PARTTYPENAME) === idx);
const distinctUOM = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.UOMTYPENAME === x.UOMTYPENAME) === idx);

@Component({
  selector: 'PartDashboard',
  templateUrl: './PartDashboard.component.html'
})
export class PartDashboardComponent {

  public state: State = {
    skip: 0,
    take: 50,
    filter: {
      logic: 'and',
      filters: []
    }
  };
  showLoader: boolean;
 
  groups: GroupDescriptor[];
  prjId: string;
  userId: string;
  file: File;
  Invoicedata: any;
  selectedInvoiceNumber: any;
  fileSected: boolean;
  readyToUploadChallanFile: boolean;
  readyToUploadInvoiceFile: boolean;
  defaultStartDate: string;
  defaultEndDate: string;
  dateRangeModal: any;
  
 


  private loadProducts(): void {
    this.gridinventory = process(this.Invoicedata, { group: this.groups });
  }
  public gridinventory: GridDataResult;


  public pieData = [
    { category: "0-14", value: 0.2545 },
    { category: "15-24", value: 0.1552 },
    { category: "25-54", value: 0.4059 },
    { category: "55-64", value: 0.0911 },
    { category: "65+", value: 0.0933 },
  ];

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private loaderService: LoaderService,
    public router: Router,
    //public _inventory: InventoryService
  ) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
    this.fileSected = false;
    this.readyToUploadChallanFile = true;
    this.readyToUploadInvoiceFile = true;
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    this.defaultStartDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
    this.defaultEndDate = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.dateRangeModal = { beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() }, endDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() } };

       
 var  pieData = [
    { category: "0-14", value: 0.2545 },
    { category: "15-24", value: 0.1552 },
    { category: "25-54", value: 0.4059 },
    { category: "55-64", value: 0.0911 },
    { category: "65+", value: 0.0933 },
  ];

  }



  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }

  

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridinventory = process(this.Invoicedata, this.state);
    if (state && state.group) {
      this.gridinventory = process(this.Invoicedata, this.state);
    }
  }

  downloadExcelFile(vehicleInfoData) {
    const ws_name = 'PartInfo';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(vehicleInfoData);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'PartInfo.xlsx');
  }
  s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  }


ngOnInit() {
    this.prjId = this.auth.getAuthentication().projectId;
    this.userId = this.auth.getAuthentication().id;
    let fromDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
    let toDate = moment(this.defaultEndDate).format('YYYY-MM-DD');



    // var dates =  moment().add(1, 'days').format("YYYY-MM-DD");

    this.getLastDatePartsQty();



    var config = {
			authDomain: "ecogreen-citizen-app.firebaseapp.com",
			apiKey: 'AIzaSyAHMkYkbjRTa9RazdKPJjtOJrdHCZVxxYg',
			databaseURL: 'HttpClient s://ecogreen-citizen-app-2ad05.firebaseio.com/',
			storageBucket: 'ecogreen-citizen-app.appspot.com',
			projectId: 'ecogreen-citizen-app'
		};
		firebase.initializeApp(config);

    
  }



  onDateRangeChangedPartReport(dateRange){

    if (dateRange.beginDate.day > 0) {
      this.defaultStartDate = dateRange.beginDate.year + "-" + dateRange.beginDate.month + "-" + dateRange.beginDate.day
      this.defaultEndDate = dateRange.endDate.year + "-" + dateRange.endDate.month + "-" + dateRange.endDate.day
     
     
    
    } else if (dateRange.beginDate.day == 0) {
      this.defaultStartDate = this.defaultStartDate
      this.defaultEndDate = this.defaultEndDate
 
    }

  }
 




  getLastDatePartsQty(){


    var data = {

         'selectDate':'2022-12-12'

    }

    this.http.post(environment.apiUrl + 'maintenance/getLastDatePartsQty',data).subscribe((data) => {
  
    });


    
  

  }







}



// WEBPACK FOOTER //
// ./src/app/maintenance/part/PartDashboard/PartDashboard.component.ts